export default {
  affectedPermissionData: ({ affectedPermissionData }) => affectedPermissionData || null,

}
